import { Bell } from 'lucide-react';
import { Switch } from '@/components/ui/switch';

export type ReminderConfig = {
  id: string;
  label: string;
  active: boolean;
  time?: string;
  frequency?: string;
};

interface RemindersSectionProps {
  reminders: ReminderConfig[];
  onToggle: (id: string, active: boolean) => void;
  onEdit?: (id: string) => void;
}

export const RemindersSection = ({ reminders, onToggle }: RemindersSectionProps) => {
  return (
    <div className="bg-card rounded-2xl p-5 shadow-card space-y-4">
      <div className="flex items-center gap-2 mb-2">
        <Bell className="h-4 w-4 text-primary" />
        <h3 className="text-sm font-semibold text-foreground">Recordatorios</h3>
      </div>
      
      <div className="space-y-3">
        {reminders.map((reminder) => (
          <div 
            key={reminder.id} 
            className={`flex items-center justify-between p-3 rounded-xl border ${reminder.active ? 'bg-primary/5 border-primary/10' : 'bg-muted/30 border-transparent'} transition-colors`}
          >
            <div className="flex-1 min-w-0 pr-4">
              <h4 className={`text-sm font-medium ${reminder.active ? 'text-foreground' : 'text-muted-foreground'}`}>
                {reminder.label}
              </h4>
              
              <div className="flex items-center gap-3 mt-1">
                <span className={`text-[10px] font-bold uppercase tracking-wider ${reminder.active ? 'text-primary' : 'text-muted-foreground'}`}>
                  {reminder.active ? 'Activo' : 'Inactivo'}
                </span>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <Switch 
                checked={reminder.active} 
                onCheckedChange={(v) => onToggle(reminder.id, v)} 
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

